// Port of the mobile app's lib/alertEvents.ts. Acknowledging happens in the
// alerts modal, but the meter panel's alerts tile and the home cards' badges
// keep their own copy of the alerts. The modal announces an acknowledgement
// here and they patch their copy, so no count stays stale.

import type { MeAlert } from './api';

export type AlertAcknowledged = {
  deveui: string;
  alert: MeAlert;
};

type Listener = (event: AlertAcknowledged) => void;

const listeners = new Set<Listener>();

export function onAlertAcknowledged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function announceAlertAcknowledged(event: AlertAcknowledged): void {
  for (const l of listeners) l(event);
}

// withAcknowledged returns `alerts` with the acknowledged one swapped in by
// name — the same list back when it isn't there, so callers can skip a
// state update.
export function withAcknowledged(
  alerts: MeAlert[] | undefined,
  alert: MeAlert,
): MeAlert[] | undefined {
  if (!alerts?.some((a) => a.name === alert.name)) return alerts;
  return alerts.map((a) => (a.name === alert.name ? alert : a));
}
